import React, { ChangeEvent } from "react";
import Form from "react-bootstrap/Form";
import Field from "./Field";

interface InputProps {
  label?: React.ReactNode;
  value?: string;
  border?: string;
  margin?: string;
  placeholder?: string;
  svg?: React.ReactNode;
  icon?: string;
  hint?: string;
  error?: string;
  required?: boolean;
  name?: string;
  // Default `email` works for most cases. Use `username` on login forms
  // when you want password managers to pair this field with a
  // `current-password` field below it. Browsers ignore "off" for login
  // forms, so we never set it — that's how the email field ended up
  // showing username suggestions.
  autoComplete?: "email" | "username" | "off";
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

const Email: React.FC<InputProps> = ({
  label = "Email address",
  value,
  placeholder = "john@bolle.com",
  svg,
  border,
  margin,
  icon = "bi-envelope",
  hint,
  error,
  required,
  name = "email",
  autoComplete = "email",
  onChange,
  ...rest
}) => {
  return (
    <Field
      label={label}
      margin={margin}
      icon={svg ? undefined : icon}
      iconNode={svg}
      hint={hint}
      error={error}
      required={required}
    >
      <Form.Control
        className={border}
        type="email"
        inputMode="email"
        value={value}
        placeholder={placeholder}
        name={name}
        onChange={onChange}
        autoComplete={autoComplete}
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
        {...rest}
      />
    </Field>
  );
};

export default Email;
